// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as PlaidRouteImport } from './routes/plaid'
import { Route as OpenRouteImport } from './routes/open'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as LayoutAppRouteImport } from './routes/_layout-app'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutTermsRouteImport } from './routes/_layout/terms'
import { Route as LayoutSecurityRouteImport } from './routes/_layout/security'
import { Route as LayoutRoadmapRouteImport } from './routes/_layout/roadmap'
import { Route as LayoutPrivacyRouteImport } from './routes/_layout/privacy'
import { Route as LayoutFeaturesRouteImport } from './routes/_layout/features'
import { Route as LayoutDeleteAccountRouteImport } from './routes/_layout/delete-account'
import { Route as LayoutContactRouteImport } from './routes/_layout/contact'
import { Route as LayoutChangelogRouteImport } from './routes/_layout/changelog'
import { Route as LayoutAboutRouteImport } from './routes/_layout/about'
import { Route as LayoutAppAppSettingsRouteImport } from './routes/_layout-app/app/settings'
import { Route as LayoutAppAppPushTestRouteImport } from './routes/_layout-app/app/push-test'
import { Route as LayoutAppAppChatsRouteImport } from './routes/_layout-app/app/chats'
import { Route as LayoutCompareIndexRouteImport } from './routes/_layout/compare/index'
import { Route as LayoutBlogIndexRouteImport } from './routes/_layout/blog/index'
import { Route as LayoutCompareSlugRouteImport } from './routes/_layout/compare/$slug'
import { Route as LayoutBlogSlugRouteImport } from './routes/_layout/blog/$slug'
import { Route as LayoutAppAppSettingsSubscriptionRouteImport } from './routes/_layout-app/app/settings/subscription'
import { Route as LayoutAppAppSettingsReceiptForwardingRouteImport } from './routes/_layout-app/app/settings/receipt-forwarding'
import { Route as LayoutAppAppSettingsProfileRouteImport } from './routes/_layout-app/app/settings/profile'
import { Route as LayoutAppAppSettingsLinkedAccountsRouteImport } from './routes/_layout-app/app/settings/linked-accounts'
import { Route as LayoutAppAppSettingsAppearanceRouteImport } from './routes/_layout-app/app/settings/appearance'
import { Route as LayoutAppAppSettingsAlertsRouteImport } from './routes/_layout-app/app/settings/alerts'
import { Route as LayoutAppAppChatsChatIdRouteImport } from './routes/_layout-app/app/chats/$chatId'

const AuthReceiptForwardingVerifyLazyRouteImport = createFileRoute('/auth/receipt-forwarding/verify')()
const LayoutAppAppIndexLazyRouteImport = createFileRoute('/_layout-app/app/')()
const LayoutAppAppTransactionsLazyRouteImport = createFileRoute('/_layout-app/app/transactions')()
const LayoutAppAppSupportLazyRouteImport = createFileRoute('/_layout-app/app/support')()
const LayoutAppAppReceiptsLazyRouteImport = createFileRoute('/_layout-app/app/receipts')()
const LayoutAppAppBudgetLazyRouteImport = createFileRoute('/_layout-app/app/budget')()
const LayoutAppAppBrandGuideLazyRouteImport = createFileRoute('/_layout-app/app/brand-guide')()

const SignOutRoute = SignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/sign-out.lazy').then((d) => d.Route))
const PlaidRoute = PlaidRouteImport.update({
            id: '/plaid',path: '/plaid',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/plaid.lazy').then((d) => d.Route))
const OpenRoute = OpenRouteImport.update({
            id: '/open',path: '/open',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/open.lazy').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/auth.lazy').then((d) => d.Route))
const LayoutAppRoute = LayoutAppRouteImport.update({
            id: '/_layout-app',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_layout-app.lazy').then((d) => d.Route))
const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_layout.lazy').then((d) => d.Route))
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/index.lazy').then((d) => d.Route))
const LayoutTermsRoute = LayoutTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/terms.lazy').then((d) => d.Route))
const LayoutSecurityRoute = LayoutSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/security.lazy').then((d) => d.Route))
const LayoutRoadmapRoute = LayoutRoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => LayoutRoute
          })
const LayoutPrivacyRoute = LayoutPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/privacy.lazy').then((d) => d.Route))
const LayoutFeaturesRoute = LayoutFeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/features.lazy').then((d) => d.Route))
const LayoutDeleteAccountRoute = LayoutDeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/delete-account.lazy').then((d) => d.Route))
const LayoutContactRoute = LayoutContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/contact.lazy').then((d) => d.Route))
const LayoutChangelogRoute = LayoutChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/changelog.lazy').then((d) => d.Route))
const LayoutAboutRoute = LayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/about.lazy').then((d) => d.Route))
const AuthReceiptForwardingVerifyLazyRoute = AuthReceiptForwardingVerifyLazyRouteImport.update({
            id: '/receipt-forwarding/verify',path: '/receipt-forwarding/verify',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/receipt-forwarding/verify.lazy').then((d) => d.Route))
const LayoutAppAppIndexLazyRoute = LayoutAppAppIndexLazyRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/index.lazy').then((d) => d.Route))
const LayoutAppAppTransactionsLazyRoute = LayoutAppAppTransactionsLazyRouteImport.update({
            id: '/app/transactions',path: '/app/transactions',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/transactions.lazy').then((d) => d.Route))
const LayoutAppAppSupportLazyRoute = LayoutAppAppSupportLazyRouteImport.update({
            id: '/app/support',path: '/app/support',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/support.lazy').then((d) => d.Route))
const LayoutAppAppReceiptsLazyRoute = LayoutAppAppReceiptsLazyRouteImport.update({
            id: '/app/receipts',path: '/app/receipts',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/receipts.lazy').then((d) => d.Route))
const LayoutAppAppBudgetLazyRoute = LayoutAppAppBudgetLazyRouteImport.update({
            id: '/app/budget',path: '/app/budget',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/budget.lazy').then((d) => d.Route))
const LayoutAppAppBrandGuideLazyRoute = LayoutAppAppBrandGuideLazyRouteImport.update({
            id: '/app/brand-guide',path: '/app/brand-guide',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/brand-guide.lazy').then((d) => d.Route))
const LayoutAppAppSettingsRoute = LayoutAppAppSettingsRouteImport.update({
            id: '/app/settings',path: '/app/settings',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/settings.lazy').then((d) => d.Route))
const LayoutAppAppPushTestRoute = LayoutAppAppPushTestRouteImport.update({
            id: '/app/push-test',path: '/app/push-test',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/push-test.lazy').then((d) => d.Route))
const LayoutAppAppChatsRoute = LayoutAppAppChatsRouteImport.update({
            id: '/app/chats',path: '/app/chats',getParentRoute: () => LayoutAppRoute
          }).lazy(() => import('./routes/_layout-app/app/chats.lazy').then((d) => d.Route))
const LayoutCompareIndexRoute = LayoutCompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/compare/index.lazy').then((d) => d.Route))
const LayoutBlogIndexRoute = LayoutBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/blog/index.lazy').then((d) => d.Route))
const LayoutCompareSlugRoute = LayoutCompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/compare/$slug.lazy').then((d) => d.Route))
const LayoutBlogSlugRoute = LayoutBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/blog/$slug.lazy').then((d) => d.Route))
const LayoutAppAppSettingsSubscriptionRoute = LayoutAppAppSettingsSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/subscription.lazy').then((d) => d.Route))
const LayoutAppAppSettingsReceiptForwardingRoute = LayoutAppAppSettingsReceiptForwardingRouteImport.update({
            id: '/receipt-forwarding',path: '/receipt-forwarding',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/receipt-forwarding.lazy').then((d) => d.Route))
const LayoutAppAppSettingsProfileRoute = LayoutAppAppSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/profile.lazy').then((d) => d.Route))
const LayoutAppAppSettingsLinkedAccountsRoute = LayoutAppAppSettingsLinkedAccountsRouteImport.update({
            id: '/linked-accounts',path: '/linked-accounts',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/linked-accounts.lazy').then((d) => d.Route))
const LayoutAppAppSettingsAppearanceRoute = LayoutAppAppSettingsAppearanceRouteImport.update({
            id: '/appearance',path: '/appearance',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/appearance.lazy').then((d) => d.Route))
const LayoutAppAppSettingsAlertsRoute = LayoutAppAppSettingsAlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => LayoutAppAppSettingsRoute
          }).lazy(() => import('./routes/_layout-app/app/settings/alerts.lazy').then((d) => d.Route))
const LayoutAppAppChatsChatIdRoute = LayoutAppAppChatsChatIdRouteImport.update({
            id: '/$chatId',path: '/$chatId',getParentRoute: () => LayoutAppAppChatsRoute
          }).lazy(() => import('./routes/_layout-app/app/chats/$chatId.lazy').then((d) => d.Route))





const LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,LayoutChangelogRoute: LayoutChangelogRoute,LayoutContactRoute: LayoutContactRoute,LayoutDeleteAccountRoute: LayoutDeleteAccountRoute,LayoutFeaturesRoute: LayoutFeaturesRoute,LayoutPrivacyRoute: LayoutPrivacyRoute,LayoutRoadmapRoute: LayoutRoadmapRoute,LayoutSecurityRoute: LayoutSecurityRoute,LayoutTermsRoute: LayoutTermsRoute,LayoutIndexRoute: LayoutIndexRoute,LayoutBlogSlugRoute: LayoutBlogSlugRoute,LayoutCompareSlugRoute: LayoutCompareSlugRoute,LayoutBlogIndexRoute: LayoutBlogIndexRoute,LayoutCompareIndexRoute: LayoutCompareIndexRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)




const LayoutAppAppChatsRouteChildren = {
  LayoutAppAppChatsChatIdRoute: LayoutAppAppChatsChatIdRoute
}

const LayoutAppAppChatsRouteWithChildren = LayoutAppAppChatsRoute._addFileChildren(LayoutAppAppChatsRouteChildren)




const LayoutAppAppSettingsRouteChildren = {
  LayoutAppAppSettingsAlertsRoute: LayoutAppAppSettingsAlertsRoute,LayoutAppAppSettingsAppearanceRoute: LayoutAppAppSettingsAppearanceRoute,LayoutAppAppSettingsLinkedAccountsRoute: LayoutAppAppSettingsLinkedAccountsRoute,LayoutAppAppSettingsProfileRoute: LayoutAppAppSettingsProfileRoute,LayoutAppAppSettingsReceiptForwardingRoute: LayoutAppAppSettingsReceiptForwardingRoute,LayoutAppAppSettingsSubscriptionRoute: LayoutAppAppSettingsSubscriptionRoute
}

const LayoutAppAppSettingsRouteWithChildren = LayoutAppAppSettingsRoute._addFileChildren(LayoutAppAppSettingsRouteChildren)



const LayoutAppRouteChildren = {
  LayoutAppAppChatsRoute: LayoutAppAppChatsRouteWithChildren,LayoutAppAppPushTestRoute: LayoutAppAppPushTestRoute,LayoutAppAppSettingsRoute: LayoutAppAppSettingsRouteWithChildren,LayoutAppAppBrandGuideLazyRoute: LayoutAppAppBrandGuideLazyRoute,LayoutAppAppBudgetLazyRoute: LayoutAppAppBudgetLazyRoute,LayoutAppAppReceiptsLazyRoute: LayoutAppAppReceiptsLazyRoute,LayoutAppAppSupportLazyRoute: LayoutAppAppSupportLazyRoute,LayoutAppAppTransactionsLazyRoute: LayoutAppAppTransactionsLazyRoute,LayoutAppAppIndexLazyRoute: LayoutAppAppIndexLazyRoute
}

const LayoutAppRouteWithChildren = LayoutAppRoute._addFileChildren(LayoutAppRouteChildren)




const AuthRouteChildren = {
  AuthReceiptForwardingVerifyLazyRoute: AuthReceiptForwardingVerifyLazyRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,LayoutAppRoute: LayoutAppRouteWithChildren,AuthRoute: AuthRouteWithChildren,OpenRoute: OpenRoute,PlaidRoute: PlaidRoute,SignOutRoute: SignOutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)